import { memo } from "react";
import { View } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { PressableScale } from "pressto";
import { Icon, type IconNameType } from "@src/components/Icon";

type VideoControlButtonProps = {
  icon: IconNameType;
  onPress?: () => void;
  disabled?: boolean;
  size?: "small" | "large";
};

export const VideoControlButton = memo(
  ({ icon, onPress, disabled = false, size = "small" }: VideoControlButtonProps) => {
    const { theme } = useUnistyles();

    const isLarge = size === "large";
    const containerSize = isLarge ? theme.spacing["13xl"] : theme.spacing["10xl"];
    const iconSize = isLarge ? theme.spacing["8xl"] : theme.spacing["6xl"];

    return (
      <PressableScale
        onPress={onPress}
        enabled={!disabled}
        style={{ opacity: disabled ? 0.3 : 1 }}
        hitSlop={theme.spacing["3xl"]}
      >
        <View
          style={[
            styles.container,
            {
              width: containerSize,
              height: containerSize,
              borderRadius: containerSize / 2,
            },
          ]}
        >
          <Icon name={icon} size={iconSize} color={theme.colors.mediaOverlay.foreground} />
        </View>
      </PressableScale>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  container: {
    backgroundColor: theme.colors.mediaOverlay.backgroundMedium,
    alignItems: "center",
    justifyContent: "center",
  },
}));
